export default {"src":"/_next/static/media/logo.422ccaad.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};